import { authAxiosClient } from '@/lib';
import { PaginatedApiResponse, PaginatedData } from '@/types';
import { withLogger } from '@/utils';

import { usersAPIUrls } from '../data';
import { User } from '../types';

type Param = {
  searchString: string;
  status: string[];
  page: number;
  rowsPerPage: number;
};

type Users = Array<User>;
type Return = PaginatedData<Array<User>>;

export type GetUsers = {
  param: Param;
  return: Return;
};

export const getUsers = withLogger(
  async ({
    searchString: search,
    status,
    page,
    rowsPerPage: per_page,
  }: Param): Promise<Return> => {
    const { data } = await authAxiosClient.get<PaginatedApiResponse<Users>>(
      usersAPIUrls.get,
      {
        params: {
          search,
          status,
          page,
          per_page,
        },
      },
    );

    return data;
  },
);
